import AuthService, { AuthEvent } from '../../common/services/AuthService';
import { localStorageService } from '../../common/services/LocalStorageService';
import Logger from '../../utils/logging/Logger';
import { lmaReduxStore } from '@redux/store';
import { appSlice } from '@redux/app.slice';
import { ConfigKey, getEnvVariable } from '@legacy-modules/common/services/EnvironmentConfigurationService';

export default class AlertsService {
  static queryInterval = 60000;
  static backoffInterval = AlertsService.queryInterval * 60;
  authService: AuthService;
  logger: Logger;
  running: boolean;
  httpPath: string;

  constructor(authService: AuthService) {
    this.authService = authService;
    this.logger = Logger.getInstance('AlertsService');
    this.running = false;
    this.httpPath = 'alerts';
    this.authService.eventEmitter.on(AuthEvent.EVENT_LOGGED_IN, this._onLoggedIn.bind(this));
  }

  destruct() {
    this.running = false;
    this.authService.eventEmitter.removeListener(AuthEvent.EVENT_LOGGED_IN, this._onLoggedIn.bind(this));
  }

  async _onLoggedIn() {
    if (!this.running) {
      this.running = true;
      await this._queryAlerts();
    }
  }

  _queryAlerts() {
    const alertsPromise = this.fetchAlerts();
    alertsPromise
      .then((response) => response.json())
      .then((json) => {
        const { alerts } = json;
        const alertSeenTimestamp = Number(localStorageService.getRaw('alertSeenTimestamp', '0'));
        lmaReduxStore.dispatch(appSlice.actions.setAlerts(JSON.parse(JSON.stringify(alerts))));
        lmaReduxStore.dispatch(appSlice.actions.setAlertSeenTime(alertSeenTimestamp));
        if (this.running) {
          setTimeout(() => this._queryAlerts(), AlertsService.queryInterval);
        }
      })
      .catch(() => {
        if (this.running) {
          setTimeout(() => this._queryAlerts(), AlertsService.backoffInterval);
        }
      });
    return alertsPromise;
  }

  acknowledgeAlerts(): void {
    const alertSeenTime = new Date().getTime() * 1000;
    lmaReduxStore.dispatch(appSlice.actions.setAlertSeenTime(alertSeenTime));
    localStorageService.setRaw('alertSeenTimestamp', '' + alertSeenTime);
  }

  async fetchAlerts() {
    const url = `${getEnvVariable(ConfigKey.HTTP_API_URL)}/${this.httpPath}`;
    return fetch(url, { headers: { token: lmaReduxStore.getState().auth.tokenId } });
  }
}
